import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addClientAsync, getClientByIdAsync, getClientsAsync, getUnassignedClientsAsync, updateClientAsync } from './clientThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const clientSlice = createSlice({
    name: 'client',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(addClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getClientsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getClientsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.clients = action.payload;
        })
            .addCase(getClientsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUnassignedClientsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUnassignedClientsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.unAssignedClients = action.payload.map((client) => ({
                id: client.id,
                name: client.name,
                broker: client.broker,
                contactPersons: client.contactPersons.map((contactPerson) => ({
                    id: contactPerson.id,
                    name: ` ${contactPerson.firstName}  ${contactPerson.lastName}`
                }))
            }));
        })
            .addCase(getUnassignedClientsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getClientByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getClientByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.client = action.payload;
        })
            .addCase(getClientByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.client = action.payload;
        })
            .addCase(updateClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default clientSlice.reducer;
